<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
      <wt-form-table-list ref="warningRecordTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="isShow" slot-scope="data">
          <span>{{ data.row.isShow === 1 ? '是' : '否' }}</span>
        </template>
      </wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>
export default {
  name: 'DeliveryHomeApplianceType',
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_HOMEAPPLIANCETYPE',
        formComponent: {
          add: { type: 'component', componentName: 'DeliveryHomeApplianceTypeEdit', value: 'resetGarbageDeliveryTypeDetailData' },
          edit: { type: 'component', componentName: 'DeliveryHomeApplianceTypeEdit', value: 'queryGarbageDeliveryTypeDetailData', noRequest: true },
          list: { type: 'default', value: '/modules/garbageDeliveryType/garbageDeliveryTypeList', params: { type: 2 }},
          delete: { type: 'default', value: '/modules/garbageDeliveryType/garbageDeliveryTypeDelete' }
        },
        formInputsData: [{ name: '物品名称', key: 'name', value: '', type: 'text' }],
        formButtonsData: [{ name: '新增', key: 'ADD', action: 'ADD', className: 'primary', hidden: false, permission: 'ADD' },
          { name: '删除', key: 'DELETE', action: 'DELETE_LIST', className: 'danger', hidden: false, permission: 'DELETE' }],
        formTableData: [
          { name: '物品名称', key: 'name', type: 'text' },
          { name: '兑换积分(个)', key: 'integral', type: 'text' },
          { name: '减少树木砍伐(颗/个)', key: 'tree', type: 'text' },
          { name: '减少碳排放(kg/个)', key: 'carbon', type: 'text' },
          { name: '减少石油消耗(吨/个)', key: 'oil', type: 'text' },
          { name: '是否在小程序显示', key: 'isShow', type: 'custom' }],
        formTableButtonsData: [{ name: '编辑', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: false, permission: 'EDIT' },
          { name: '删除', key: 'DELETE', action: 'DELETE', className: 'danger', hidden: false, permission: 'DELETE' }],
        formResult: { },
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true }
      },
      formDialog: {
        visible: true,
        title: ''
      }
    }
  },
  methods: {
    onButtonAction(data) {
      console.log(data.row)
      if (data && data.item) {
        if (data.item.action === 'VIEW' || data.item.action === 'EDIT') {
          this.$store.dispatch('setGarbageDeliveryTypeDetailData', JSON.parse(JSON.stringify(data.row)))
        }
      }
    }
  }
}
</script>

<style>
</style>
